export default (classes: Record<string, unknown> | unknown[]) =>
  (
    (Array.isArray(classes) && classes) ||
    Object.entries(classes).map(([key, value]) => !!value && key)
  )
    .filter(Boolean)
    .join(' ');
